import gapi from "./api.js";

const MIMEText = require('mimetext')

const CLIENT_ID = '287332754418-i5tr50d1nbn9si5n0ob0shojpnhv9lt9.apps.googleusercontent.com';
const API_KEY = 'AIzaSyDv1kkrtKZnjpTRfbgZTDJMSWya6Qpwwt4';
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest"];
const SCOPES = 'https://mail.google.com/';

let isInitialized;
function init() {
    if (!isInitialized) {
        isInitialized = new Promise(res => {
            gapi.load('client:auth2', () => {
                gapi.client.init({
                    apiKey: API_KEY,
                    clientId: CLIENT_ID,
                    discoveryDocs: DISCOVERY_DOCS,
                    scope: SCOPES
                })
                    .then(() => res(true))
                    .catch(error => console.log(error))
            });
        });
    }
    return isInitialized;
}

function decodeHTML(html) {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
}

let gmail = {
    notifications:{
        display(message, body, actions) {
            if (Notification.permission === 'granted') {
                navigator.serviceWorker.ready.then(function(serviceWorker) {
                    serviceWorker.showNotification(message, {
                        body: body,
                        icon: "/img/icons/favicon-96x96.png",
                        vibrate: [100, 50, 100],
                        actions: actions
                    });
                });
            }
        }
    },
    messages: {
        list() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.messages.labels.list({'userId': 'me'}))
                .then(response => response.result.messages);
        },
        get() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.messages.labels.list({'userId': 'me'}))
                .then(response => response.result.messages);
        },
        getByLabels(labels = []) {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.users.messages.list({'userId': 'me', labelIds: labels, maxResults:50}))
                .then(async response => {
                    if(!response.result.messages) return [];

                    const batch = gapi.client.newBatch();
                    const searchRequest = function(id) {
                        return gapi.client.request({
                            'path': 'gmail/v1/users/me/messages/' + id
                        });
                    };

                    for (const message of response.result.messages)
                        batch.add(searchRequest(message.id))

                    const batchedMessages = (await batch).result;
                    const messages = [];

                    console.log(batchedMessages)

                    for (const messageId in batchedMessages) {
                        const message = batchedMessages[messageId];

                        const getBody = (part) => {
                            if (part.body && part.body.data) return part.body.data;
                            let allParts = flattenParts([], part);
                            let bodyPart = allParts.find(p => p.mimeType === 'text/html') ||  allParts.find(p => p.mimeType === 'text/plain');
                            if (bodyPart) return bodyPart.body.data;
                        }
                        const flattenParts = (acc, part) => {
                            if (!acc) acc = [];
                            if (part && part.body && part.body.data) acc.push(part);
                            if (part.parts) acc = part.parts.reduce(flattenParts, acc);
                            return acc;
                        }
                        let body = getBody(message.result.payload);

                        messages.push({
                            id:message.result.id,
                            from:Array.from(message.result.payload.headers).find(item => item.name === 'From').value,
                            to:Array.from(message.result.payload.headers).find(item => item.name === 'To').value,
                            date:Array.from(message.result.payload.headers).find(item => item.name === 'Date').value,
                            subject:Array.from(message.result.payload.headers).find(item => item.name === 'Subject').value,
                            snippet:message.result.snippet,
                            body:atob(body.replace(/-/g, '+').replace(/_/g, '/'))
                        })
                    }

                    return messages.sort((a,b) => new Date(b.date) - new Date(a.date));
                });
        },
        async send(to, subject, body) {
            const profile = await gmail.user.get();
            const mail = new MIMEText();
            mail.setSender(profile['emailAddress']);
            mail.setRecipient(to);
            mail.setSubject(subject);
            mail.setMessage(decodeHTML(body));

            console.log(profile, mail, decodeHTML(body), body);

            return Promise.resolve(isInitialized)
                .then(() => {
                    gapi.client.gmail.users.messages.send({
                        userId: 'me',
                        resource: {
                            raw: mail.asEncoded()
                        }
                    }).then(result => result).catch(error => error);
                })
        }
    },
    labels: {
        get() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.users.labels.list({'userId': 'me'}))
                .then(response => response.result.labels);
        },
        list() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.users.labels.list({'userId': 'me'}))
                .then(response => response.result.labels);
        }
    },
    user: {
        get() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.users.getProfile({'userId': 'me'}))
                .then(response => response.result);
        },
        isSignedIn() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.auth2.getAuthInstance().isSignedIn.get());
        },
        signIn() {
            gapi.auth2.getAuthInstance().signIn();
        },
        signOut() {
            gapi.auth2.getAuthInstance().signOut();
        }
    },
    threads: {
        get() {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.threads.labels.list({'userId': 'me'}))
                .then(response => response.result.threads);
        },
        getByLabels(labels = []) {
            return Promise.resolve(isInitialized)
                .then(() => gapi.client.gmail.users.threads.list({'userId': 'me', labelIds: labels}))
                .then(response => response.result.threads);
        }
    },
}

export default {
    install (Vue) {
        init().then(() => {
            gapi.auth2.getAuthInstance().isSignedIn.listen(() => window.dispatchEvent(new CustomEvent("gmailStateChange", {
                detail: {
                    isSignedIn: gmail.user.isSignedIn()
                }
            })));
        });
        Vue.prototype.$gmail = gmail;
        Vue.$gmail = gmail;
    }
}